/**
 * 초 단위 시간을 시:분:초 형태로 포맷팅합니다.
 * @param seconds 초 단위 시간 (number 또는 string)
 * @returns 시:분:초 형태의 문자열 (예: "1:23:45", "0:05:30", "0:00:15")
 */
export const formatDuration = (seconds: number | string | null | undefined): string => {
  if (!seconds) {
    return '0:00:00';
  }

  const numSeconds = typeof seconds === 'string' ? parseFloat(seconds) : seconds;

  if (isNaN(numSeconds) || numSeconds <= 0) {
    return '0:00:00';
  }

  const hours = Math.floor(numSeconds / 3600);
  const minutes = Math.floor((numSeconds % 3600) / 60);
  const remainingSeconds = Math.floor(numSeconds % 60);

  return `${hours}:${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`;
};

/**
 * 초 단위 시간을 분:초 형태로 포맷팅합니다 (기존 호환성을 위해 유지).
 * @param seconds 초 단위 시간 (number 또는 string)
 * @returns 분:초 형태의 문자열 (예: "5:30", "123:45")
 */
export const formatDurationMinSec = (seconds: number | string | null | undefined): string => {
  if (!seconds) {
    return '0:00';
  }

  const numSeconds = typeof seconds === 'string' ? parseFloat(seconds) : seconds;

  if (isNaN(numSeconds) || numSeconds <= 0) {
    return '0:00';
  }

  const minutes = Math.floor(numSeconds / 60);
  const remainingSeconds = Math.floor(numSeconds % 60);

  return `${minutes}:${String(remainingSeconds).padStart(2, '0')}`;
};

/**
 * 날짜 시간을 포맷팅합니다.
 * @param date 날짜 시간 (string)
 * @returns 날짜 시간 형태의 문자열 (예: "11/03/2025, 12:00:00")
 */
export const formatDateTime = (date: string): string => {
  if (!date) {
    return '-';
  }
  return new Date(date).toLocaleString('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false, // 24-hour format without AM/PM
  });
};
